var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarouselButton = function SvgCarouselButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#F9F2EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.195 8.19584C9.935 8.45584 9.935 8.87584 10.195 9.13584L12.7817 11.7225L10.195 14.3092C9.935 14.5692 9.935 14.9892 10.195 15.2492C10.455 15.5092 10.875 15.5092 11.135 15.2492L14.195 12.1892C14.455 11.9292 14.455 11.5092 14.195 11.2492L11.135 8.18917C10.8817 7.93584 10.455 7.93584 10.195 8.19584Z",
    fill: "#8C9E89"
  })));
};
export default SvgCarouselButton;